import React, { lazy, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
//import { useTheme } from '@windmill/react-ui';

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const CreateAccount = lazy(() => import('./pages/CreateAccount'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
 
function App() {
  let history = useHistory();
useEffect(() => {
    // This will run once when component mounts
    const forceDarkTheme = () => {
      // Remove any existing theme classes
      document.documentElement.classList.remove('mode-light', 'mode-dark');
      
      // Add dark theme class
      document.documentElement.classList.add('mode-dark');
      
      // Set localStorage
      localStorage.setItem('theme', 'dark');
      
      // Update meta theme color for mobile
      updateMetaThemeColor(); 
    };

    const updateMetaThemeColor = () => {
      let metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (!metaThemeColor) {
        metaThemeColor = document.createElement('meta');
        metaThemeColor.name = 'theme-color';
        document.head.appendChild(metaThemeColor);
      }
      metaThemeColor.content = '#1a202c'; // Dark theme color
    };

    forceDarkTheme();

    // Optional: Listen for theme changes if you have a toggle
    const handleStorageChange = (e) => {
      if (e.key === 'theme') {
        forceDarkTheme(); // Keep forcing dark theme
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Route path="/login" component={Login} />
          {/* <Route path="/create-account" component={CreateAccount} />
          <Route path="/forgot-password" component={ForgotPassword} /> */}

          {/* Place new routes over this */}
          <Route path="/app" component={Layout} />
          {/* If you have an index page, you can remothis Redirect */}
          <Redirect exact from="/" to="/app/dashboard" />
        </Switch>
      </Router>
    </>
  )
}

export default App
